var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector 9 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M8 0.870679L7.15659 -4.3997e-07L4 3.25864L0.843411 -1.64013e-07L-1.80498e-07 0.870679L4 5L8 0.870679Z","fill":"#0C4425"}));
}

DownArrow.defaultProps = {"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
